// let's get this party started




document.addEventListener('DOMContentLoaded', function () {


  // SWIPER 
  // kbpp
  const kbppSwiper = new Swiper('.js_kbppslider', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    resistanceRatio: 0,
    // freeMode: {
    //   enabled: true,
    //   momentumBounce: false,
    //   // momentum: false,
    //   momentumRatio: 0.4,
    //   // momentumVelocityRatio: 0.4,
    // },
    navigation: {
      prevEl: '.slider__arrow_prev',
      nextEl: '.slider__arrow_next',
    },
    breakpoints: {
      768: {
        spaceBetween: 24,
        // freeMode: false,
      },
    },
  });

  // horizon
  const horizonSwiper = new Swiper('.js_horizonslider', {
    slidesPerView: 1,
    spaceBetween: 20,
    resistanceRatio: 0,
    pagination: {
      el: '.swiper-pagination',
      type: "fraction",
    },
    navigation: {
      prevEl: '.slider__arrow_prev',
      nextEl: '.slider__arrow_next',
    },
    breakpoints: {
      768: {
        spaceBetween: 24,
      },
    },
  });

  // feedb
  const feedbSwiper = new Swiper('.js_feedbslider', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    resistanceRatio: 0,
    navigation: {
      prevEl: '.slider__arrow_prev',
      nextEl: '.slider__arrow_next',
    },
    breakpoints: {
      768: {
        spaceBetween: 24,
      },
    },
  });

  // steps
  (function () {
    // breakpoint where swiper will be destroyed
    // and switches to a dual-column layout
    const breakpoint = window.matchMedia('(min-width:768px)');

    // keep track of swiper instances to destroy later
    let gallerySwiper;

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    const breakpointChecker = function () {

      // if larger viewport and multi-row layout needed
      if (breakpoint.matches === true) {

        // clean up old instances and inline styles when available
        if (gallerySwiper !== undefined) gallerySwiper.destroy(true, true);

        // or/and do nothing
        return;

        // else if a small viewport and single column layout needed
      } else if (breakpoint.matches === false) {

        // fire small viewport version of swiper
        return enableSwiper();
      }
    };

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    const enableSwiper = function () {

      gallerySwiper = new Swiper('.js_stepslider:not(.swiper-initialized)', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        resistanceRatio: 0,
      });

    };

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    if (document.querySelector('.js_stepslider')) {

      // keep an eye on viewport size changes
      breakpoint.addEventListener('change', breakpointChecker);
      // kickstart
      breakpointChecker();
    }
  })(); /* IIFE end */








  // ADD YEAR
  const currYear = new Date().getFullYear();
  if (currYear > 2023) {
    document.querySelectorAll('.js_year').forEach(item => {
      item.innerHTML = `${currYear}`;
    });
  }


  // GET SOME PRICES
  const coinTarget = document.getElementById('thecoin');
  if (coinTarget) {
    const jsonLink = 'https://www.antpool.com/api/v3/minerInfo/miner/detail?id=271&coinType=BTC'
    // const jsonLink = 'https://www.coincalculators.io/api?hashrate=110000000000000&name=Bitcoin'
    // const jsonLink = 'https://www.coincalculators.io/api?hashrate=110000000000000&power=3250&powercost=0.05&algorithm=SHA-256'
    var getJSON = function (url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'json';
      xhr.onload = function () {
        var status = xhr.status;
        if (status === 200) {
          callback(null, xhr.response);
        } else {
          callback(status, xhr.response);
        }
      };
      xhr.send();
    };

    getJSON(jsonLink,
      function (err, data) {
        if (err !== null) {
          console.log('Something went wrong: ' + err);
        } else {
          coinTarget.innerHTML = Math.round(data.data.supportCoinsDeltail[0].earnUsd);
        }
      });
  }

  // ======================






  const body = document.body;


  // DOTS
  const dotsMin = document.querySelector('.p-pool') ? 3 : 5;
  const dotsMax = document.querySelector('.p-pool') ? 5 : 7;
  let dotsLimitTop = 100,
    dotsLimitBottom = 0;

  if (document.querySelector('.p-pool')) {
    dotsLimitTop = 1;
    dotsLimitBottom = 10;
  }
  if (document.querySelector('.p-mining')) {
    dotsLimitTop = 1;
    dotsLimitBottom = 7;
  }



  function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  // function randomLeft(min, max) {
  //   let left = random(min, max);
  //   if (left > 35 && left < 50) {
  //     left = random(10, 35)
  //   }
  //   if (left > 49 && left < 65) {
  //     left = random(65, 90)
  //   }
  //   return left;
  // }
  const dotColors = ['#FF531A', '#79A398', '#E3E7E5']
  document.querySelectorAll('.dots').forEach(item => {
    // const theNumber = random(5, 7);
    const theNumber = random(dotsMin, dotsMax);
    for (let i = 0; i <= theNumber; i++) {
      const size = random(6, 13);
      let top = i * (100 / theNumber) + random(-70, 70) * 0.1;

      const left = random(10, 90);

      if (top < 0) {
        top = random(0, 30) * 0.1;
      }
      if (top > 100) {
        top = 99;
      }
      if (top >= dotsLimitTop && top <= dotsLimitBottom) {
        top = 150
      }

      item.insertAdjacentHTML('beforeend', `<div class="dot" style="width: ${size}px; height: ${size}px; background: ${dotColors[random(0, 2)]}; left: ${left}%;top: ${top.toFixed(2)}%;"></div>`);
    }
  });




  // =============



  // CUSTOM CURSOR
  const cursor = document.querySelector('#cursor');

  let isTouchCursor = false;

  if (cursor) {
    body.classList.add('m-cursor');
    document.addEventListener('mousemove', function (e) {
      if (!isTouchCursor) {
        body.classList.add('m-cursor');
        cursor.classList.remove('m-hidden');
        cursor.style.transform = `translate(${e.clientX}px,${e.clientY}px)`;
      }
    });

    body.addEventListener('mouseleave', () => {
      body.classList.remove('m-cursor');
    });

    // hide on touch events
    let touchTimeout;
    body.addEventListener('touchstart', (e) => {
      cursor.classList.add('m-hidden');
      clearTimeout(touchTimeout);
      isTouchCursor = true;
      touchTimeout = setTimeout(() => {
        isTouchCursor = false;
      }, 500);
    });

    // active state on hover

    document.querySelectorAll('a, button, input, select, textarea, .cursor-active').forEach(item => {
      item.addEventListener('mouseenter', () => {
        cursor.classList.add('m-active');
      });
      item.addEventListener('mouseleave', () => {
        cursor.classList.remove('m-active');
      });
    });



    // drolling on click
    document.addEventListener('mousedown', () => {
      cursor.classList.add('m-click');
    });
    document.addEventListener('mouseup', () => {
      cursor.classList.remove('m-click');
    });

  }
  // ==========================



  // STUFF ON SCROLL
  function onScroll() {
    // detect scroll
    const scrolledGap = 42;
    const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    scrollTop > scrolledGap
      ? document.body.classList.add('m-scrolled')
      : document.body.classList.remove('m-scrolled');
    // =========
  }
  onScroll();
  let throttlescroll;
  window.addEventListener('scroll', function () {
    clearTimeout(throttlescroll)
    throttlescroll = setTimeout(function () {
      onScroll();
    }, 50)
  }, false)
  // ========================

  // SCROLL TO
  const scroller = new SweetScroll(
    {
      trigger: '[data-scroll]',
      header: '[data-scroll-header]',
      duration: 1000,
      easing: 'easeInOutSine',
      offset: 0,
      vertical: true,
      horizontal: false,
      cancellable: true,
      updateURL: false,
      preventDefault: true,
      stopPropagation: true,
      before: () => {
        cursor.classList.remove('m-active');
      },
      after: (offset, $trigger, scroller) => {
        // move focus to target
        let targetItem;
        if (!$trigger && offset.top === 0) {
          targetItem = document.body;
        } else if ($trigger && $trigger.getAttribute('href')) {
          targetItem = document.querySelector($trigger.getAttribute('href'));
        } else if ($trigger && $trigger.getAttribute('data-scroll').substring(0, 1) === '#') {
          targetItem = document.querySelector($trigger.getAttribute('data-scroll'));
        }
        if (targetItem) {
          targetItem.focus();
          if (targetItem !== document.activeElement) {
            targetItem.setAttribute('tabindex', '-1');
            targetItem.focus();
            targetItem.blur();
            targetItem.removeAttribute('tabindex');
          }
        }
        if ($trigger && $trigger.getAttribute('href') === "#block-form-demo") {
          const inputTarget = targetItem.querySelector('input[type="email"]');
          if (inputTarget) inputTarget.focus();
        }
      },
    },
  );

  document.querySelectorAll('[data-scroll-top]').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      scroller.toTop(0);
    });
  });


  //===============================

  function checkScrollbar() {
    //Get real width of page scroll-bar
    const w1 = document.documentElement.clientWidth;
    document.querySelector('html').classList.add('popup_lock');
    const w2 = document.documentElement.clientWidth;
    document.querySelector('html').classList.remove('popup_lock');
    return w2 - w1;
  }



  // FULL POPUP STUFF
  function bodyStopScroll() {
    const scrollWidth = checkScrollbar();
    const stopScrollStyle = `
      <style id="scrollStuff">
        html {overflow: hidden;}
        body, .js_popup_show_margin { padding-right: ${scrollWidth}px; }
        body { width:auto; }
      </style>
    `;
    document.head.insertAdjacentHTML('beforeend', stopScrollStyle);
    document.body.classList.add('noscroll');
  }
  function bodyRemoveStopScroll() {
    if (document.head.querySelector('#scrollStuff')) {
      document.head.querySelector('#scrollStuff').remove();
    }
    document.body.classList.remove('noscroll');
  }


  // ==============





  document.querySelectorAll('.js_popup_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const popupTarget = trigger.getAttribute('href')
        ? document.querySelector(trigger.getAttribute('href'))
        : document.querySelector(trigger.getAttribute('data-target'));
      bodyStopScroll();
      popupTarget.classList.add('m-active');

      trigger.classList.add('focusHolder');

      setTimeout(() => {
        popupTarget.setAttribute('tabindex', '-1');
        popupTarget.focus();
        popupTarget.blur();
        popupTarget.removeAttribute('tabindex');
      }, 500);

      // if (window.matchMedia("(min-width: 768px)").matches) {
      //   setTimeout(() => {
      //     if (popupTarget.getAttribute('id') === 'block-form-request') {
      //       const inputTarget = popupTarget.querySelector('input[type="email"]');
      //       if (inputTarget) inputTarget.focus();
      //     }
      //   }, 500);
      // }


    });
  });


  document.querySelectorAll('.js_popup_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  });


  let isEsc = false;
  document.addEventListener('keyup', function (event) {
    if (event.key === "Escape") {
      isEsc = true;
      closePopup();
    }
  });

  function closePopup() {
    const activePopup = document.querySelector('.js_popup.m-active');
    if (activePopup) {
      activePopup.classList.remove('m-active');
      setTimeout(() => {
        bodyRemoveStopScroll();

        const focusTarget = document.querySelector('.focusHolder');
        if (focusTarget) {
          focusTarget.focus();
          if (!isEsc) {
            focusTarget.blur();
          }
          focusTarget.classList.remove('focusHolder');
        }
        isEsc = false;
      }, 300);
    }
    else {
      isEsc = false;
    }
  }

  // ==========================




  // ACTIVE TOGGLE
  let toggleHold = false;
  document.querySelectorAll('.js_toggle_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!toggleHold) {
        toggleHold = true;
        let toggleTarget = ''
        if (trigger.getAttribute('data-target')) {
          toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
        } else if (trigger.getAttribute('href')) {
          toggleTarget = document.querySelector(trigger.getAttribute('href'))
        } else {
          toggleTarget = trigger.closest('.js_toggle');
        }
        trigger.classList.toggle('m-active');
        toggleTarget.classList.toggle('m-active');

        setTimeout(() => {
          toggleHold = false;
        }, 500);
      }
    });
  });


  // ========================
  // ========================

  document.querySelectorAll('.js_burger_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      const burger = document.querySelector('.js_burger.m-active');
      if (burger) burger.click();
    });
  });




  // 

  let stopscrollHold = false;
  document.querySelectorAll('.js_stopscroll').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      if (window.matchMedia("(max-width: 767.98px)").matches) {
        e.preventDefault();
        if (!stopscrollHold) {
          stopscrollHold = true;
          if (!document.body.classList.contains('noscroll')) {
            bodyStopScroll();
          } else {
            setTimeout(() => {
              bodyRemoveStopScroll();
            }, 500);
          }
          setTimeout(() => {
            stopscrollHold = false;
          }, 500);
        }
      }
    });
  });


  // ON HORIZONTAL RESIZE
  // - remove bodystopscroll
  let winWidth = window.innerWidth;
  let throttleresize;
  window.addEventListener('resize', function () {
    let newWinWidth = window.innerWidth;
    if (newWinWidth !== winWidth) {
      newWinWidth = newWinWidth;
      clearTimeout(throttleresize)
      throttleresize = setTimeout(function () {

        if (window.matchMedia("(min-width: 768px)").matches) {
          bodyRemoveStopScroll();
        }

      }, 150)
    }
  }, false)

});





// =================================================
// =================================================
// =================================================

